import { render, staticRenderFns } from "./QuoteInfo.vue?vue&type=template&id=946b23ba&scoped=true"
import script from "./QuoteInfo.vue?vue&type=script&lang=js"
export * from "./QuoteInfo.vue?vue&type=script&lang=js"
import style0 from "./QuoteInfo.vue?vue&type=style&index=0&id=946b23ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "946b23ba",
  null
  
)

export default component.exports